import { Component, type ComponentClass, type FC, Fragment } from "react";
import SectionsSettingsTemplate from "../components/templates/SectionsSettingsTemplate/index";
import { SectionProvider } from "../contexts/section";
import { StudentTagFilterInterface } from "../domains/StudentTag";
import { WithRouterProps, withRouter } from "../helpers/RouterHelper";
import { StudentFilterInterface } from "../interfaces/FiltersInterface";
import { OperatorPrivilege } from "../interfaces/OperatorInterface";
import enhanceAuthenticatedPage, {
  AuthenticatedPageCallbacks,
  AuthenticatedPageProps,
  AuthenticateRouterProps,
  DispatchProps,
  StateProps,
} from "./enhanceAuthenticatedPage";

export interface SectionsSettingsPageProps
  extends WithRouterProps<AuthenticateRouterProps>,
    AuthenticatedPageProps,
    AuthenticatedPageCallbacks,
    DispatchProps,
    StateProps {}

interface PageInfoInterface {
  title: string;
}

const enhanceSectionsSettingsPage = (
  WrappedComponent: ComponentClass<any, any> | FC<any>,
  pageInfo: PageInfoInterface,
  requiredPrivileges?: OperatorPrivilege[],
) => {
  class SectionsPage extends Component<SectionsSettingsPageProps> {
    get studentFilter(): StudentFilterInterface | undefined {
      const tagFilter = this.props.params.sectionId
        ? this.props.studentFilterContext.currentFilter
        : undefined;
      return {
        sectionId: this.props.params.sectionId || "",
        tagFilter: tagFilter || ({} as StudentTagFilterInterface),
      };
    }

    render() {
      if (
        !this.props.currentSection.data ||
        !this.props.currentOperator ||
        !this.studentFilter ||
        !this.props.operatorPrivileges.data
      ) {
        return null;
      }

      return (
        <Fragment>
          <SectionsSettingsTemplate
            pageInfo={{
              title: pageInfo.title,
            }}
          >
            <SectionProvider value={this.props.currentSection.data}>
              <WrappedComponent
                {...this.props}
                section={this.props.currentSection.data}
                tagFilter={this.studentFilter.tagFilter}
              />
            </SectionProvider>
          </SectionsSettingsTemplate>
        </Fragment>
      );
    }
  }
  return withRouter<SectionsSettingsPageProps>(
    enhanceAuthenticatedPage(SectionsPage, requiredPrivileges),
  );
};

export default enhanceSectionsSettingsPage;
